import { render } from "./AduanMasyarakat.vue?vue&type=template&id=48a6ccc1"
import script from "./AduanMasyarakat.vue?vue&type=script&lang=js"
export * from "./AduanMasyarakat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__